/**
 * Which closure reasons an interruption offers (JBWEB-1089). The admin first
 * says who asks — the company or the temp worker — and each side has its own
 * reasons, their type in the database. Some also depend on the mission: the
 * early return of the person replaced only for a replacement, a trial ending
 * only within the trial period.
 */
export const closureReasonsFor = ({
  reasons = [],
  requester,
  isReplacement = false,
  withinTrialPeriod = false,
}) => {
  if (!requester) return [];
  return reasons.filter(
    (reason) =>
      reason.type === requester &&
      (!reason.replacement_only || isReplacement) &&
      (!reason.trial_period_only || withinTrialPeriod),
  );
};
